<template>
  <div class="deepa-chat-view d-flex flex-column flex-grow-1">
    <DeepAChatMessageList
      v-if="messages.length > 0"
      class="flex-grow-1"
      :messages
    />
    <div
      v-else
      class="d-flex flex-column flex-grow-1 align-center justify-center ga-3 pa-6 text-center text-medium-emphasis text-body-medium"
    >
      <DeepAppIcon height="40" logo="deepa" width="40" />
      {{ t('deepa_chat.empty_state') }}
    </div>

    <div v-if="visibleOtherLocation" class="flex-shrink-0 px-4 pt-2">
      <v-alert
        closable
        data-test-id="deepa-chat-other-location"
        density="compact"
        :icon="false"
        type="info"
        variant="tonal"
        @click:close="dismissedLocationId = visibleOtherLocation.nodeId"
      >
        <v-btn
          class="text-none px-1"
          color="info"
          density="compact"
          name="btn-deepa-chat-start-other-location"
          prepend-icon="far fa-plus"
          size="small"
          variant="text"
          @click="newChat([visibleOtherLocation])"
        >
          {{
            t('deepa_chat.start_chat_for', {
              name: getContextNodeName(visibleOtherLocation),
            })
          }}
        </v-btn>
      </v-alert>
    </div>

    <DeepAChatPrompt
      class="flex-shrink-0"
      :disabled="contextNodes.length === 0"
      :loading
      @send="send"
      @stop="stop"
    />
  </div>
</template>

<script lang="ts" setup>
import DeepAChatMessageList from '@/pocs/chat/components/DeepAChatMessageList.vue'
import DeepAChatPrompt from '@/pocs/chat/components/DeepAChatPrompt.vue'
import { useDeepAContextNodeName } from '@/pocs/chat/composables/context-node'
import { useContextDeepAChat } from '@/pocs/chat/composables/ctx-deepa-chat'
import { DeepAppIcon } from '@deepcloud/deep-ui-lib'

const { t } = useI18n()

const getContextNodeName = useDeepAContextNodeName()

const { contextNodes, messages, loading, otherLocation, newChat, send, stop } =
  useContextDeepAChat()

const dismissedLocationId = ref<string>()

const visibleOtherLocation = computed(() =>
  otherLocation.value?.nodeId === dismissedLocationId.value
    ? undefined
    : otherLocation.value,
)
</script>

<style lang="scss" scoped>
.deepa-chat-view {
  min-height: 0;
}
</style>
